import axios from 'axios';
import { getApiHeader } from './../services/getApiHeaders';

export function getDetailItemNameMaster(payload) {
    let { channelId, sku } = payload
    return axios({
        method: 'GET',
        url: `${process.env.REACT_APP_URL}/api/itemname/getitemnamebysku?channelId=${channelId}&sku=${sku}`,
        headers: getApiHeader(),
        withCredentials: true,
        data: {},
    })
}


// WEBPACK FOOTER //
// ./src/utils/getDetailItemNameMaster.js